<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex xs12>
        <v-card elevation="2">
          <v-card-text>
            <h1><v-icon class="iconTitle">mdi-file-document-multiple</v-icon> Documentación</h1><br>
            <v-layout>
              <v-flex xs2>
                <v-menu
                  v-model="menuCalendarStartDoc"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  style="width: 30%"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filterDateStartDocFormatted"
                      label="Desde"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="getDocuments(); changeDateFormattedDoc('dateStartDoc');" locale="es" :first-day-of-week="1" v-model="filterDateStartDoc"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs2>
                <v-menu
                  v-model="menuCalendarEndDoc"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="filterDateEndDocFormatted"
                      label="Hasta"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                    ></v-text-field>
                  </template>
                  <v-date-picker @change="getDocuments(); changeDateFormattedDoc('dateEndDoc');" locale="es" :first-day-of-week="1" v-model="filterDateEndDoc"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  v-model="searchDoc"
                  label="Escriba para buscar un documento según título, productor o tipo"
                  prepend-inner-icon="mdi-magnify"
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-btn v-on:click="newDoc()" text class="btnMini">
                  <v-icon large>mdi-plus</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-list two-line subheader>
      <v-list-item
        v-for="item in filteredItemsDoc"
        :key="item.id"
      >
        <v-list-item-avatar>
          <v-icon
            :class="[item.iconClass]"
            v-text="item.icon"
          ></v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="item.title"></v-list-item-title>
          <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-btn icon @click="openDocument(item.id, item.type)">
            <v-icon color="grey lighten-1">mdi-file</v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn icon @click="downloadDocument(item.id, item.title, item.type)">
            <v-icon color="grey lighten-1">mdi-download</v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn icon @click="sendDocument(item.id)">
            <v-icon color="grey lighten-1">mdi-account-network</v-icon>
          </v-btn>
        </v-list-item-action>
        <v-list-item-action>
          <v-btn icon @click="deleteDocument(item.id)">
            <v-icon color="grey lighten-1">mdi-delete</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <showDialog ref="dialog" />
    <showMessage ref="snackbar" />
  </v-container>
</template>
<script>
import {BASE_URL} from '../components/constants.js'
import * as basics from '../components/basics.js'
import genericReload from '../components/genericReload';
import showDialog from '../components/Dialog.vue'
import showMessage from '../components/Messages.vue'
export default {
  name: 'Documentacion',
  data: () => ({
    menuCalendarStartDoc: false,
    menuCalendarEndDoc: false,
    filterDateStartDoc: '',
    filterDateEndDoc: '',
    filterDateStartDocFormatted: '',
    filterDateEndDocFormatted: '',
    searchDoc: '',
    searchDocuments: [],
    documents: [],
  }),
  components: {
    showDialog,
    showMessage,
  },
  mounted(){
    this.filterDateStartDoc = basics.getDate("month", -1);
    this.filterDateEndDoc = basics.getDate();
    this.filterDateStartDocFormatted = basics.formatDate(this.filterDateStartDoc,"dd/mm/yyyy");
    this.filterDateEndDocFormatted = basics.formatDate(this.filterDateEndDoc,"dd/mm/yyyy");
    this.getDocuments();
    setTimeout(() => this.searchDocuments = this.documents)
  },
  computed: {
    filteredItemsDoc() { 
      return this.searchDocuments.filter((item) =>{
          return item.title.match(this.searchDoc) || item.title.toLowerCase().match(this.searchDoc) || item.subtitle.match(this.searchDoc) || item.subtitle.toLowerCase().match(this.searchDoc)
      })
    }
  },
  methods: {
    async newDoc(){
      this.$refs.dialog.setNew("Subir nuevo documento", "", "newDoc").then(async (confirm) => {
        if(confirm.response){          
          let formData = new FormData();
          formData.append('documento', confirm.file);
          // const xhr = new XMLHttpRequest();
          // xhr.open('POST', `${BASE_URL}/documento`);
          // xhr.setRequestHeader('Authorization', 'Bearer '+this.$store.state.auth)
          // xhr.responseType = 'json';

          // // log response
          // xhr.onload = () => {
          //   switch (xhr.response.status) {
          //     case "ok":
          //       this.$refs.snackbar.setNew(true, "Documento subido correctamente", "Ok", "green");
          //       this.getDocuments();
          //       break;
          //     default:
          //       this.$refs.snackbar.setNew(true, basics.returnError(response.status), "Cerrar", "red");
          //       break;
          //   }
          // };
          // xhr.send(formData);
          const headers = {
            'Authorization': 'Bearer '+this.$store.state.auth
          };

          const response = await fetch(
            `${BASE_URL}/documento`,
            {
              method: 'POST',
              headers: headers,
              body: formData,
            }
          );
          switch (response.status) {
            case 200:
              this.$refs.snackbar.setNew(true, "Documento subido correctamente", "Ok", "green");
              this.getDocuments();
              break;
            default:
              this.$refs.snackbar.setNew(true, basics.returnError(response.status), "Cerrar", "red");
              break;
          }
        }else{
          this.$refs.snackbar.setNew(true, "El documento NO se ha subido", "Cerrar", "red");
        }
      })
    },
    async sendDocument(id){
      this.$refs.dialog.setNew("Enviar documento", "", "sendDoc").then(async (confirm) => {
        if(confirm.response){
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+this.$store.state.auth
          };
          const data = {
            idsProductor: JSON.parse(JSON.stringify(confirm.productor))
          }

          const response = await fetch(
            `${BASE_URL}/documento/${id}/send`,
            {
              method: 'POST',
              headers: headers,
              body: JSON.stringify(data),
            }
          );
          switch (response.status) {
            case 200:
              this.$refs.snackbar.setNew(true, "Documento enviado correctamente", "Ok", "green");
              break;
            default:
              this.$refs.snackbar.setNew(true, "ERROR. El documento no se ha enviado", "Cerrar", "red");
              break;
          }
        }else{
          this.$refs.snackbar.setNew(true, "El documento NO se ha enviado", "Cerrar", "red");
        }
      })
    },
    getIconType(mimetype){
      const [type, subtype] = mimetype.split("/");
      switch(subtype){
        case "pdf":
          return {icon: "mdi-file-pdf-box", iconClass: "red"}
        case "msword":
          return {icon: "mdi-file-word", iconClass: "blue"}
        case "vnd.openxmlformats-officedocument.wordprocessingml.document":
          return {icon: "mdi-file-word", iconClass: "blue"}
        case "msexcel":
          return {icon: "mdi-file-excel", iconClass: "green"}
        case "vnd.ms-excel":
          return {icon: "mdi-file-excel", iconClass: "green"}
        case "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
          return {icon: "mdi-file-excel", iconClass: "green"}
        case "vnd.ms-powerpoint":
          return {icon: "mdi-file-powerpoint", iconClass: "orange"}
        case "vnd.openxmlformats-officedocument.presentationml.presentation":
          return {icon: "mdi-file-powerpoint", iconClass: "orange"}
      }
      switch(type){
        case "image":
          return {icon: "mdi-file-image", iconClass: "yellow"}
        case "audio":
          return {icon: "mdi-book-music", iconClass: "red"}
        case "video":
          return {icon: "mdi-file-video", iconClass: "purple"}
        case "text":
          return {icon: "mdi-file-document-outline", iconClass: "grey"}
        
      }
    },
    async getDocuments(){
      this.documents = [];
      setTimeout(() => this.searchDocuments = this.documents);
      const response = await genericReload(this.$store.state.auth, 'documento/?fechaInicio='+this.filterDateStartDoc+'&fechaFin='+this.filterDateEndDoc);
      if (response.status === 200) {
        const json = await response.json();
        if(json.status="ok"){
          let body = json.body;
          for(let i=0; i<body.length; i++){
            let type = this.getIconType(body[i].MIMEType);
            let sub = ""; let productor = "";
            if(body[i].idProductor){
              productor = this.$store.getters.productorById(body[i].idProductor);
              sub = "Fecha subida: "+basics.formatDate(body[i].fechaSubida,"dd/mm/yyyy")+" | Enviado por: "+productor.nombre;
            }else{
              sub = "Fecha subida: "+basics.formatDate(body[i].fechaSubida,"dd/mm/yyyy");
            }
            this.documents.push({id: body[i].id, type: body[i].MIMEType, icon: type.icon, iconClass: type.iconClass+" white--text", title: body[i].nombre, subtitle: sub});
          }
          setTimeout(() => this.searchDocuments = this.documents);
        }
      }
    },
    openDocument(id, type){
      let xhr = new XMLHttpRequest();
      xhr.open('GET', BASE_URL+'/documento/'+id+'/download', true);
      xhr.setRequestHeader('Authorization', 'Bearer '+this.$store.state.auth);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        let blob = xhr.response;
        // let blob = new Blob([xhr.response], { type: type });
        let fileURL = URL.createObjectURL(blob);
        window.open(fileURL, '_blank');
      }
      xhr.onerror = function () {
        switch(xhr.status){
          case 400:
            this.$refs.snackbar.setNew(true, "Error en la aplicación. Consulte a soporte técnico.", "Cerrar", "red");
            break;
          case 401:
            this.$refs.snackbar.setNew(true, "Datos de inicio de sesión erróneos.", "Cerrar", "red");
            break;
          case 500:
            this.$refs.snackbar.setNew(true, "Error en el servidor. Consulte a soporte técnico.", "Cerrar", "red");
            break;
        }
      }
      xhr.send();
    },
    downloadDocument(id, name, type){
      let xhr = new XMLHttpRequest();
      xhr.open('GET', BASE_URL+'/documento/'+id+'/download', true);
      xhr.setRequestHeader('Authorization', 'Bearer '+this.$store.state.auth);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        //let blob = xhr.response;
        let blob = new Blob([xhr.response], { type: type });
        let fileURL = URL.createObjectURL(blob);
        let fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', name);
        document.body.appendChild(fileLink);
        fileLink.click();
      }
      xhr.onerror = function () {
        switch(xhr.status){
          case 400:
            this.$refs.snackbar.setNew(true, "Error en la aplicación. Consulte a soporte técnico.", "Cerrar", "red");
            break;
          case 401:
            this.$refs.snackbar.setNew(true, "Datos de inicio de sesión erróneos.", "Cerrar", "red");
            break;
          case 500:
            this.$refs.snackbar.setNew(true, "Error en el servidor. Consulte a soporte técnico.", "Cerrar", "red");
            break;
        }
      }
      xhr.send();
    },
    async deleteDocument(id){
      this.$refs.dialog.setNew("¿Estás seguro de llevar a cabo esta operación?", "Se eliminará el documento.").then(async (confirm) => {
        if(confirm.response){
          this.$refs.dialog.setNew("Es necesaria una doble confirmación", "Está intentando llevar a cabo una operación en la que pueden perderse datos irrecuperables. ¿Estás seguro?").then(async (confirm) => {
            if(confirm.response){
              const headers = {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer '+this.$store.state.auth
              };

              const response = await fetch(
                `${BASE_URL}/documento/${id}`,
                {
                  method: 'DELETE',
                  headers: headers,
                }
              );
              switch (response.status) {
                case 200:
                  this.$refs.snackbar.setNew(true, "Documento eliminado correctamente", "Ok", "green");
                  this.getDocuments();
                  break;
                default:
                  this.$refs.snackbar.setNew(true, "ERROR. El documento no se ha eliminado", "Cerrar", "red");
                  break;
              }
            }else{
              this.$refs.snackbar.setNew(true, "El documento NO se ha borrado", "Cerrar", "red");
            }
          })
        }else{
          this.$refs.snackbar.setNew(true, "El documento NO se ha borrado", "Cerrar", "red");
        }
      })
    },
    changeDateFormattedDoc(field){
      switch(field){
        case "dateStartDoc":
          this.filterDateStartDocFormatted = basics.formatDate(this.filterDateStartDoc,"dd/mm/yyyy");
          break;
        case "dateEndDoc":
          this.filterDateEndDocFormatted = basics.formatDate(this.filterDateEndDoc,"dd/mm/yyyy");
          break;
      }
    }
  }
}
</script>
<style scoped>
.v-input{
  margin-right: 1em;
}
</style>